'use client';

import { useEffect } from 'react';

import {
    Container,
    Icon,
    IconName,
    IconSize,
    Section,
    Title,
    TitleLevels,
    TitleMarkup,
    TrilogyColor,
} from '@bytel/trilogy-react';

import { TagEventType } from '@app-types/tracking';

import { Help } from '@components/help';

import useTracking from '@hooks/use-tracking';

function NotFoundHeader() {
    return (
        <Section className='has-text-centered has-pattern-dark'>
            <Container>
                <Icon name={IconName.INTERNAL_FRAUD} size={IconSize.HUGE} color={TrilogyColor.BACKGROUND} />
                <Title level={TitleLevels.ONE} markup={TitleMarkup.H1} inverted className='is-marginless'>
                    Cette page est introuvable
                </Title>
                <Title level={TitleLevels.FOUR} markup={TitleMarkup.H2} inverted>
                    Il est possible qu&apos;elle ait été supprimée, ou déplacée.
                </Title>
                <Title level={TitleLevels.FOUR} markup={TitleMarkup.H2} inverted>
                    Pas de panique, on vous aide à retrouver votre chemin.
                </Title>
            </Container>
        </Section>
    );
}

export function NotFound() {
    const { sendTag } = useTracking();
    useEffect(() => {
        sendTag(
            {
                page: 'Erreur_404',
                pageCategorie: 'Erreur',
            },
            TagEventType.DATA,
        );
    }, []);

    return (
        <>
            <NotFoundHeader />
            <Help />
        </>
    );
}
